import { Component, Injector, OnInit } from '@angular/core';
import { ModalComponent } from '../../../vass-core/components/modal/modal.component';

@Component({
  selector: 'app-taxes',
  templateUrl: './taxes.component.html',
  styleUrls: ['./taxes.component.scss'],
  standalone: false,
})
export class TaxesComponent implements OnInit {
  private modalComponent: any;
  public mortgageResult: any;
  public savingsMade: string;
  public amountNotFinanced = 0;

  constructor(private _inj: Injector) {
    this.modalComponent = this._inj.get(ModalComponent);
    if (this.modalComponent.confirmation.data) {
      this.mortgageResult = this.modalComponent.confirmation.data.dataSimulate;
      this.savingsMade = this.modalComponent.confirmation.data.savingsMade;
    }
  }

  ngOnInit() {
    if (this.mortgageResult) {
      this.amountNotFinanced =
        parseFloat(this.mortgageResult.expenses.trading.total) +
        parseFloat(this.mortgageResult.expenses.mortgage.total) +
        parseFloat(this.savingsMade);
    }
  }

  totalNotaryMortgage() {
    return this.mortgageResult
      ? parseFloat(this.mortgageResult.expenses.mortgage.notary.intervention) +
          parseFloat(this.mortgageResult.expenses.mortgage.notary.duty)
      : '0';
  }

  totalNotaryTrading() {
    return this.mortgageResult
      ? parseFloat(this.mortgageResult.expenses.trading.notary.intervention) +
          parseFloat(this.mortgageResult.expenses.trading.notary.duty)
      : '0';
  }

  getBonus() {
    let bonus = 0;
    if (this.mortgageResult) {
      for (const item in this.mortgageResult.expenses.mortgage) {
        if (this.mortgageResult.expenses.mortgage[item].bonus) {
          bonus = bonus + parseFloat(this.mortgageResult.expenses.mortgage[item].bonus);
        }
      }
      for (const item in this.mortgageResult.expenses.trading) {
        if (this.mortgageResult.expenses.trading[item].bonus) {
          bonus = bonus + parseFloat(this.mortgageResult.expenses.trading[item].bonus);
        }
      }
    }
    return Math.abs(bonus);
  }

  public openToast(id: string) {
    const elementHTML: any = document.getElementById(id);
    elementHTML.blur();
    elementHTML.focus();
  }
}
